export const themes = {
  light: {
    mode: "light",
    background: "#F6F6F7",
    sidebar: "#FFFFFF",
    header: "#FCFCFC",
    text: "#161616",
    accent: "#BEDBB0",
    card: "#FFFFFF",
    border: "#BEDBB0",
    helpCard: "#F6F6F7",
    inputBg: "#FFFFFF",
    inputText: "#161616",
    inputBorder: "#BEDBB0",
  },
  dark: {
    mode: "dark",
    background: "#1F1F1F",
    sidebar: "#121212",
    header: "#161616",
    text: "#fff",
    accent: "#BEDBB0",
    card: "#232323",
    border: "#BEDBB0",
    helpCard: "#1F1F1F",
    inputBg: "#232323",
    inputText: "#fff",
    inputBorder: "#BEDBB0",
  },
  violet: {
    mode: "violet",
    background: "#ECEDFD",
    sidebar: "#5255BC",
    header: "#FFFFFF",
    text: "#161616",
    accent: "#5255BC",
    card: "#FFFFFF",
    border: "#5255BC",
    helpCard: "#8F92D6",
    inputBg: "#FFFFFF",
    inputText: "#161616",
    inputBorder: "#5255BC",
  },
};
